<template>
  <div>
    <div id="page" data-swup="0" class="device-is-android">
      <header-bar :title="$t('calendar')"></header-bar>

      <footer-bar></footer-bar>
      <div
        class="page-content header-clear-medium has-footer-menu"
        style="transform: translateX(0px)"
      >
        <Carousel :interval="4000" height="300px" arrow="always">
          <CarouselItem v-for="task in featuredTasks" :key="`ftrd_${task.id}`">
            <div
              @click="handleDetailModal({ show: true, id: task.id })"
              class="card card-style bg-1"
              data-card-height="300"
              :style="
                `height: 300px; background-repeat: no-repeat !important; background: url('${task.defaultAttachmentUrl}?w=600&h=450&mode=crop')`
              "
            >
              <div class="card-bottom">
                <h4 class="color-white px-3 mb-0">{{ getLangText(task) }}</h4>
                <p class="px-3 color-white font-15 opacity-60"></p>
              </div>
              <div class="card-overlay bg-gradient"></div>
            </div>
          </CarouselItem>
        </Carousel>
        <div class="divider mb-3"></div>

        <div class="calendar rounded-m mb-4">
          <div class="cal-footer">
            <h6 class="cal-sub-title uppercase bold bg-highlight color-white">
              {{ $t("calendar") }}
            </h6>
            <!-- <span class="cal-message mt-3 mb-3">
                        <i class="fa fa-bell font-18 color-green1-dark"></i>
                        <strong class="color-gray-dark">Reminder: Call the plumber for Kitchen Sink</strong>
                        <strong class="color-gray-dark">Reminder: Today is Karla Black's Birthday.</strong>
                    </span> -->
            <div class="divider mb-0"></div>
            <div
              class="cal-schedule"
              @click="handleDetailModal({ show: true, id: task.id })"
              v-for="task in tasks"
              :key="task.id"
            >
              <em
                >{{ moment(task.d1).format("YYYY.MM.DD") }}<br />{{
                  moment(task.d1).format("HH:mm")
                }}</em
              >
              <strong>{{ getLangText(task) }}</strong>
              <span><i class="fa fa-map-marker"></i>{{ task.st3 }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="page-bg">
        <div></div>
      </div>

      <div class="divider divider-margins"></div>
    </div>
  </div>
</template>

<script>
//const moment = require("moment");
import moment from "moment";
import { Carousel, CarouselItem } from "element-ui";
import { request } from "@/api/all";
import { mapActions } from "vuex";
import footerBar from "@/views/apps/ubtzyouth/footerBar";
import headerBar from "@/views/apps/ubtzyouth/headerBar";
export default {
  components: {
    Carousel,
    CarouselItem,
    footerBar,
    headerBar,
  },
  data() {
    return {
      tasks: [],
      featuredTasks: [],
      title: "",
    };
  },
  created: function() {
    this.moment = moment;
  },
  methods: {
    ...mapActions(["handleDetailModal"]),
    getLangText(task) {
      let lng = this.$i18n.locale;
      if (lng == "en") {
        return task.st5 ?? task.task;
      } else if (lng == "ru") {
        return task.st4 ?? task.task;
      } else if (lng == "cn") {
        return task.st6 ?? task.task;
      } else {
        return task.task;
      }
    },
    init() {
      request({
        api: { method: "POST", url: "taskCore/getCoreList" },
        data: {
          skip: 0,
          size: 100,
          ot: 357,
          model: {
            isPublic: true,
            locTypeId1: this.$route.params.id,
            i1: 0,
          },
        },
        store: this.$store,
      }).then((res) => {
        this.tasks = _.sortBy(res.data.tasks, "ord", "asc");
      });
      request({
        api: { method: "POST", url: "taskCore/getCoreList" },
        data: {
          skip: 0,
          size: 100,
          ot: 357,
          model: {
            isPublic: true,
            locTypeId1: this.$route.params.id,
            i1: 1,
          },
        },
        store: this.$store,
      }).then((res) => {
        this.featuredTasks = _.sortBy(res.data.tasks, "ord", "asc");
      });
      request({
        api: { method: "get", url: "Type/GetInheritedDetail" },
        params: {
          id: this.$route.params.id,
        },
        store: this.$store,
      }).then((res) => {
        this.title = res.data.name;
      });
    },
  },
  mounted() {
    this.init();
  },
  watch: {
    "$root.$route"(newRoute, oldRoute) {
      if (newRoute.params.id != oldRoute.params.id) {
        this.init();
      }
    },
  },
};
</script>
<style scoped></style>
